var _style, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoWatch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9,8.1l-0.6-3.6C21,3.1,19.8,2,18.3,2h-4.6c-1.5,0-2.7,1.1-3,2.5l-0.6,3.6C8.9,8.5,8,9.7,8,11v10c0,1.3,0.9,2.5,2.1,2.9  l0.6,3.6c0.2,1.5,1.5,2.5,3,2.5h4.6c1.5,0,2.7-1.1,3-2.5l0.6-3.6c1.2-0.4,2.1-1.5,2.1-2.9V11C24,9.7,23.1,8.5,21.9,8.1z M22,21  c0,0.6-0.4,1-1,1H11c-0.6,0-1-0.4-1-1V11c0-0.6,0.4-1,1-1h10c0.6,0,1,0.4,1,1V21z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWatch);
export default __webpack_public_path__ + "static/media/logo_watch.bc903aa1.svg";
export { ForwardRef as ReactComponent };